import {SubmitHandler} from 'react-hook-form'

import {ProcessWorkOrderForm} from '../../components'
import {useCreateProcessWorkOrder} from '../../hooks'
import {mapProcessWorkOrderFormValuesToCreateDto} from '../../mappers'
import {
  HProduceTask,
  ProcessWorkOrderAssignee,
  ProcessWorkOrderCreateDto,
  ProcessWorkOrderDto,
  ProcessWorkOrderFormValues,
  TaskSource
} from '../../types'

type Props = {
  onCancel: () => void
  onSubmit?: (next: HProduceTask) => void
  onTaskTypeChange: (taskType: TaskSource | undefined) => void
}

export const CreateProcessWorkOrderContainer = ({onCancel, onSubmit, onTaskTypeChange}: Props) => {
  const {mutateAsync: createProcessWorkOrder} = useCreateProcessWorkOrder()
  const handleSubmit: SubmitHandler<ProcessWorkOrderFormValues> = async (formData) => {
    const dataDto: ProcessWorkOrderCreateDto = mapProcessWorkOrderFormValuesToCreateDto(formData)
    await createProcessWorkOrder(dataDto, {
      onSuccess: (data: ProcessWorkOrderDto) => {
        onSubmit?.({
          ...data,
          created: data.createdAt,
          externalId: data.id,
          source: TaskSource.PROCESS_WORK_ORDER,
          assignees: Array.isArray(data.assignees)
            ? data.assignees.map((assignee: ProcessWorkOrderAssignee) => assignee.user)
            : []
        })
      }
    })
  }

  return (
    <ProcessWorkOrderForm
      onSubmit={handleSubmit}
      onCancel={onCancel}
      onTaskTypeChange={onTaskTypeChange}
      disableChecklistsSelect={false}
    />
  )
}
